import { Link as SystemLink } from '@hover/blueprint';
import React from 'react';
import { Trans } from 'react-i18next';
import { useLocation } from 'react-router';

import { Link } from 'src/shared/components';
import { useInvalidateEmptyQuery } from 'src/shared/graphql/cache';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { Route } from 'src/shared/route';
import { loginPathWithRedirectTo } from 'src/shared/utils/routing';

import { useHomeownerAppContext } from '../../hooks';
import { HomeownerAppMenuNames } from '../../providers/HomeownerAppProvider';
import type { NotFoundSplashProps } from '../errors';
import { NotFoundSplash } from '../errors';

export interface UploadNotFoundSplashProps
  extends Partial<NotFoundSplashProps> {}

const UploadNotFoundSplash = (props: UploadNotFoundSplashProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  const { loggedIn, setCurrentMenu } = useHomeownerAppContext();
  const { pathname } = useLocation();

  // We cache the 404 `null` response, so invalidate that cache so
  // that the query hits the server again after the user logs in
  const invalidateEmptyImage = useInvalidateEmptyQuery('aiOriginalImage');

  return (
    <NotFoundSplash
      callToAction={
        loggedIn ? (
          <Trans
            components={{
              HomeLink: <Link to={Route.HOMEOWNER_APP_HOME.path} />,
              UploadLink: (
                <SystemLink
                  as="button"
                  cursor="pointer"
                  onClick={() =>
                    setCurrentMenu(HomeownerAppMenuNames.UPLOAD_PHOTO)
                  }
                />
              ),
            }}
            i18nKey="originalImageScreen.notFound.callToAction"
            t={t}
          />
        ) : (
          <Trans
            components={{
              HomeLink: <Link to={Route.HOMEOWNER_APP_HOME.path} />,
              LoginLink: (
                <Link
                  onClick={invalidateEmptyImage}
                  to={loginPathWithRedirectTo(pathname)}
                />
              ),
            }}
            i18nKey="originalImageScreen.notFound.callToActionLoggedOut"
            t={t}
          />
        )
      }
      subtitle={t('originalImageScreen.notFound.uploadNotFound')}
      {...props}
    />
  );
};

export { UploadNotFoundSplash };
